// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "compiled-css" + "." + "d34c51c16b0133c5" + ".css"
}